import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "id"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "partyId"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "statusCode"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "connectionId"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "method"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "url"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "ip"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "action")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex gap-5" }
const _hoisted_13 = { class: "text-primary" }
const _hoisted_14 = { class: "text-info" }
const _hoisted_15 = { class: "text-danger" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import TableFooter from "@/components/TableFooter.vue";
import { onMounted, ref } from "vue";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import { Search } from "@element-plus/icons-vue";
import TimeShow from "@/components/TimeShow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiLog',
  setup(__props) {

const detailVisible = ref(false);

const isLoading = ref(true);
const dialogItem = ref<any>({});
const items = ref(Array<any>());
const criteria = ref<any>({
  page: 1,
  size: 20,
});

const methods = ["GET", "POST", "PUT", "DELETE"];

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  if (criteria.value.method !== null && criteria.value.method !== undefined) {
    criteria.value.method = criteria.value.method.trim().toUpperCase();
  }
  isLoading.value = true;

  try {
    const res = await TenantGlobalService.queryApiLogs(criteria.value);
    items.value = res.data;
    criteria.value = res.criteria;
    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const getDepositError = async () => {
  criteria.value = {
    page: 1,
    size: 20,
    method: "POST",
    action: "deposit",
    statusCode: 400,
  };
  await fetchData(1);
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
  };
  await fetchData(1);
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: criteria.value.partyId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.partyId) = $event)),
          style: {"max-width":"200px"},
          clearable: "",
          placeholder: "Search PartyId",
          class: "input-with-select me-4"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              disabled: isLoading.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.action,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.action) = $event)),
          style: {"max-width":"200px"},
          clearable: "",
          placeholder: "Search Action",
          class: "input-with-select me-4"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              disabled: isLoading.value,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.ip,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.ip) = $event)),
          style: {"max-width":"200px"},
          clearable: "",
          placeholder: "Search IP",
          class: "input-with-select me-4"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              disabled: isLoading.value,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.statusCode,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((criteria.value.statusCode) = $event)),
          style: {"max-width":"200px"},
          clearable: "",
          placeholder: "Search StatusCode",
          class: "input-with-select me-4"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              disabled: isLoading.value,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: criteria.value.method,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.method) = $event)),
          style: {"max-width":"150px"},
          clearable: "",
          placeholder: "Method",
          class: "input-with-select me-4",
          onChange: _cache[9] || (_cache[9] = ($event: any) => (fetchData(1)))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(methods, (item) => {
              return _createVNode(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (getDepositError())),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Show Deposit Error Log")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: reset,
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reset")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && items.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.partyId) + "(" + _toDisplayString(item.email || "null") + ")", 1),
                    _createElementVNode("td", null, _toDisplayString(item.statusCode), 1),
                    _createElementVNode("td", null, _toDisplayString(item.connectionId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method), 1),
                    _createElementVNode("td", null, _toDisplayString(item.action), 1),
                    _createElementVNode("td", null, _toDisplayString(item.ip), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        type: "exactTime",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        type: "exactTime",
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: 
                  () => {
                    dialogItem.value = item;
                    detailVisible.value = true;
                  }
                
                      }, " Details ", 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"]),
      _createVNode(_component_el_dialog, {
        modelValue: detailVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((detailVisible).value = $event)),
        title: "Detail",
        width: "1000"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.id), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.statusCode), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.connectionId), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.method), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.action), 1),
            _createElementVNode("span", null, _toDisplayString(dialogItem.value.ip), 1)
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_13, "Param: " + _toDisplayString(dialogItem.value.parameters), 1),
          _createElementVNode("div", _hoisted_14, "Request: " + _toDisplayString(dialogItem.value.requestContent), 1),
          _createElementVNode("div", _hoisted_15, " Response: " + _toDisplayString(dialogItem.value.responseContent), 1),
          _hoisted_16
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})